export const SET_FOLLOW_UP_CHECKBOXES = "SET_FOLLOW_UP_CHECKBOXES";


// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/followUpActionTypes.js